import { useState } from 'react';
import './PeopleCard.css';

const PeopleCard = ({ person, onClick, style }) => {
    const [isHovered, setIsHovered] = useState(false);

    return (
        <div
            className={`people-card ${isHovered ? 'people-card--hovered' : ''}`}
            onClick={onClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            style={style}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
                if (e.key === 'Enter' || e.key === ' ') {
                    onClick?.();
                }
            }}
        >
            {/* Primary State */}
            <div className="people-card__primary">
                <img
                    src={person.primaryPhoto}
                    alt={person.name}
                    className="people-card__image"
                    loading="lazy"
                />
                <div className="people-card__overlay">
                    <h3 className="people-card__name">{person.name}</h3>
                    <p className="people-card__accolades">{person.roles[0]}</p>
                </div>
            </div>

            {/* Hover State */}
            <div className="people-card__secondary">
                <img
                    src={person.secondaryPhoto}
                    alt={`${person.name} - alternate`}
                    className="people-card__image"
                    loading="lazy"
                />
                <div className="people-card__hover-content">
                    <h3 className="people-card__name people-card__name--hover">
                        {person.name}
                    </h3>
                    <p className="people-card__bio">{person.hoverInfo.bio}</p>
                    <div className="people-card__skills">
                        {person.profile.specializations.map((skill, index) => (
                            <span key={index} className="people-card__skill-tag">
                                {skill}
                            </span>
                        ))}
                    </div>
                    <p className="people-card__connection-reason">
                        {person.hoverInfo.connectionReason}
                    </p>
                </div>
            </div>
        </div>
    );
};

export default PeopleCard;
